import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwUser, DwUserEntity } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaData, AppMetaDataItemNames, AssignmentStudentEntity } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";
import { CourseProgressVariableContext } from "../../courses/models/course-progress-variable-context.model";
import { StudentAssignmentProgressEvent, studentAssignmentProgress } from "../models/student-assignment-progress-event.model";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";

@DwAction({
    keyName: 'course-purchase-action',
    display: 'Course Purchase Action',
    actionType: DwActionType.gridRowAction,
    parentItemName: AppMetaDataItemNames.DwUser,
    isGlobal: false,
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        permissionMeaning: AppPermissions.studentCourseCanAssign
    }
})
@Injectable()
export class CoursePurchaseActionService implements DwActionHandler {
    
    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        private dwEventService: DwEventService
    ) {
    }

    handleAction(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {
        const users : DwUserEntity[] = ensureArray(actionState.data, true);

        const userIds = users.map(x => x.UserId);

        this.dwRoutingService.navigateToUrl("/manage-users/assign-courses?userIds=" + userIds.join(','), null);
        
        const result: DwActionResult = {
            success: true
        };

        return of(result);
    }

}